<template>
  <div
    class="feedback-wrap-box"
    :class="{'feedback-wrap-box-pc':this.$platform.pc}"
  >
    <div class="feedback-wrap">
      <div class="feedback-container">
        <div class="feedback-title">
          {{ fbParams.editable ? fbParams.title : fbParams.reply[fbParams.value] }}
        </div>
        <div class="feedback-evaluation-wrap">
          <!-- 可编辑状态 -->
          <div v-if="fbParams.editable" class="feedback-evaluation">
            <div
              v-for="item in fbParams.evaluation"
              :key="item.value"
              :class="'feedback-evaluation-item' + (item.value === fbParams.value ? '_active' : '')"
              @click="setValue(item.value)"
            >
              <!-- 星星 -->
              <div
                v-if="fbParams.extendData && fbParams.extendData.styleType === 1"
                class="feedback-evaluation-icon"
                :class="'feedback-icon-start' + (item.value <= fbParams.value ? '_active' : '')"
              ></div>
              <!-- 表情 -->
              <div
                v-else
                class="feedback-evaluation-icon"
                :class="'feedback-icon-' + item.name + (item.value === fbParams.value ? '_active' : '')"
              ></div>
              <!-- 下方文字 -->
              <div
                class="feedback-evaluation-text"
                :class="'feedback-evaluation-text' + (item.value === fbParams.value ? '_active' : '')"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
          <!-- 不可编辑状态 -->
          <div v-else>
            <div
              v-for="item in fbParams.evaluation.filter(
                (sub) => sub.value === fbParams.value
              )"
              :key="item.value"
              class="feedback-evaluation-result"
            >
              <div class="feedback-evaluation-item_active">
                <!-- 星星 -->
                <div
                  v-if="
                    fbParams.extendData && fbParams.extendData.styleType === 1
                  "
                >
                  <div
                    v-for="(sub, subIndex) in Array(fbParams.value).fill(1)"
                    :key="subIndex"
                    class="feedback-icon-start_active feedback-evaluation-icon start-inline"
                  ></div>
                </div>
                <!-- 表情 -->
                <div
                  v-else
                  class="feedback-evaluation-icon"
                  :class="'feedback-icon-' + item.name + '_active'"
                ></div>
                <!-- 文本区 -->
                <div class="feedback-evaluation-item_active-text">
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="fbParams.showTags"
          class="feedback-mark-list"
          :class="fbParams.editable ? '' : 'feedback-mark-list-label'"
        >
          <!-- 可编辑时 选择tag -->
          <template v-if="fbParams.editable">
            <div
              v-for="(item, index) in fbParams.tags.filter(
                (sub) => sub.level === fbParams.value
              )"
              :key="index"
              class="feedback-tag"
              :class="'feedback-tag' + (fbParams.ids.indexOf(item.id) > -1 ? '-active' : '')"
              @click="addTags(item)"
            >
              {{ item.name }}
            </div>
          </template>
          <!-- 不可编辑时 显示tag -->
          <template v-else>
            <div
              v-for="(item, index) in fbParams.tags.filter(
                (sub) => fbParams.ids.indexOf(sub.id) > -1
              )"
              :key="index"
              class="feedback-tag"
            >
              {{ item.name }}
            </div>
          </template>
        </div>
      </div>

      <div v-if="fbParams.showOpinion" class="feedback-opinion">
        <!-- 可以编辑 意见反馈 -->
        <div v-if="fbParams.editable" class="feedback-textarea-wrap">
          <!-- 意见反馈输入 -->
          <textarea
            class="feedback-textarea"
            v-model="fbParams.text"
            :disabled="fbParams.isDemo"
            :maxlength="fbParams.availLetterSum"
            :placeholder="fbParams.placeholder"
          ></textarea>
          <div class="feedback-textarea-limit">
            <span class="feedback-textarea-limit-current">{{
              fbParams.text.length
            }}</span>
            <span class="feedback-textarea-limit-total"
              >/{{ fbParams.availLetterSum }}</span
            >
          </div>
        </div>
        <!-- 已经填写了 意见反馈 -->
        <div v-else-if="fbParams.text" class="feedback-opinion-label">
          {{ fbParams.text }}
        </div>
      </div>

      <div v-if="fbParams.showSolve">
        <div v-if="fbParams.editable" class="feedback-solvtion">
          <div class="feedback-title">是否解决了您的问题？</div>
          <div class="feedback-status">
            <div
              class="feedback-status-wrap"
              :class="'feedback-status-wrap' + (fbParams.isSolve === 1 ? '_active' : '')"
              @click="setResolved(1)"
            >
              <div
                class="feedback-status-icon"
                :class="'feedback-status-resolved' + (fbParams.isSolve === 1 ? '_active' : '')"
              ></div>
              <div>已解决</div>
            </div>
            <div
              class="feedback-status-wrap"
              :class="'feedback-status-wrap' + (fbParams.isSolve === 2 ? '_active' : '')"
              @click="setResolved(2)"
            >
              <div
                class="feedback-status-icon"
                :class="'feedback-status-unresolved' + (fbParams.isSolve === 2 ? '_active' : '')"
              ></div>
              <div>未解决</div>
            </div>
          </div>
        </div>

        <div
          v-else
          class="feedback-status"
          :class="fbParams.isSolve !== 1 && fbParams.isSolve !== 2 ? 'no-data' : ''"
        >
          <div v-if="fbParams.isSolve === 2" class="feedback-status-wrap feedback-status-wrap_label">
            <div
              class="feedback-status-icon"
              :class="'feedback-status-'+ (fbParams.isSolve === 1 ? 'resolved' : 'unresolved')"
            ></div>
            <div>{{ fbParams.isSolve === 1 ? "已解决" : "未解决" }}</div>
          </div>
          <div v-if="fbParams.isSolve === 1" class="feedback-status-wrap feedback-status-wrap_label">
            <div
              class="feedback-status-icon"
              :class="'feedback-status-' + (fbParams.isSolve === 1 ? 'resolved' : 'unresolved')"
            ></div>
            <div>{{ fbParams.isSolve === 1 ? "已解决" : "未解决" }}</div>
          </div>
        </div>
      </div>

      <div v-if="fbParams.editable" class="feedback-submit">
        <button
          class="feedback-submit-btn"
          :class="fbParams.disableSubmit ? 'is-disabled' : ''"
          @click="onSubmit"
          :disabled="fbParams.disableSubmit"
        >
          {{ $t('chat_feedback_submit_text') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import { IMSDK } from '@/imsdk/index.ts';

const imsdk = IMSDK.create();
const CGI_FEED_BACK_SUBMIT_URL = '/webim/innerPage/feedBack';

export default {
  name: 'feedback',
  // mixins: [MixinSendMsg, MixinTestMsg, MixinUi],
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    singleSeqs: {
      type: String,
      default: '',
    },
  },
  inject: ['globalData', 'wpaDetail', 'to'],
  data() {
    // 默认配置
    const defaultState = {
      disableSubmit: true, // 提交按钮是否可使用
      value: 0, // 满意度打分
      text: '', // 意见
      isSolve: 0,  // 是否解决了问题 1=解决 2=未解决(从0改造) 0=未设置(从-1改造)
      ids: [], // 添加的tag
      editable: true,
      evaluation: [{
        name: 'veryDissatisfied',
        text: this.$t('chat_feedback_very_dissatisfied_text'),
        value: 1,
      }, {
        name: 'dissatisfied',
        text: this.$t('chat_feedback_dissatisfied_text'),
        value: 2,
      }, {
        name: 'neutral',
        text: this.$t('chat_feedback_neutral_text'),
        value: 3,
      }, {
        name: 'satisfied',
        text: this.$t('chat_feedback_satisfied_text'),
        value: 4,
      }, {
        name: 'verySatisfied',
        text: this.$t('chat_feedback_very_satisfied_text'),
        value: 5,
      }],
      reply: {
        1: '很抱歉服务不周，我们会不断改进的',
        2: '很抱歉服务不周，我们会不断改进的',
        3: '很抱歉服务不周，我们会不断改进的',
        4: '感谢你的鼓励，祝你生活愉快',
        5: '感谢你的鼓励，祝你生活愉快',
      },
      title: this.$t('chat_feedback_title_text'),
      tags: [],
      placeholder: '点击此处给我们建议',
      availLetterSum: 60,
      showTags: false, // 是否显示标签列表
      showSolve: false, // 是否显示解决问题按钮
      showOpinion: false, // 是否显示意见反馈富文本框
      showTitle: false, // 是否显示意见反馈富文本框
      isMobile: false, // 是否是手机页面
      isDemo: false, // 是否是展示界面，按钮始终disabled
      extendData: { // 扩展字段，后期如果有新增字段，统一放在这
        styleType: 0, // 0代表笑脸 1代表星星
      },
    };
    // 变量整理
    const contentDefault = {
      tags: [],
      openTag: true,
      openSolve: true,
      reply: false,
      style: '',
      extendData: {},
      result: {},
    };
    let { content } = this.data;
    content = content || contentDefault;
    const tags = [];
    (content.tags || []).forEach((item, index) => {
      item.forEach((sub) => {
        tags.push(Object.assign({ level: 5 - index }, sub));
      });
    });

    const params = {
      isMobile: !this.$platform.pc,
      showTags: content.openTag === 1,
      showSolve: content.openSolve === 1,
      reply: content.reply,
      showOpinion: content.style === 2,
      showTitle: true,
      title: this.$t('chat_feedback_title_text'),
      tags,
      extendData: content.extendData,
    };

    // 从缓存中取到的数据初始化提交结果赋值，如果没有提交按照插件中默认值赋值
    const { fbLevel, fbDesc, isSolve } = content.result || {};
    params.value = fbLevel || 0;
    params.text = fbDesc || '';
    params.isSolve = isSolve || 0;
    params.editable = !fbLevel;

    return {
      msgDataBody: content,
      fbParams: { ...defaultState, ...params },
    };
  },

  computed: {
  },

  methods: {
    /**
     * 选择星级
     */
    setValue(value) {
      Object.assign(this.fbParams, { value, ids: [] });

      if (!this.fbParams.isDemo) {
        Object.assign(this.fbParams, { disableSubmit: false });
      }
    },

    /**
     * 打标签
     */
    addTags(tag) {
      const { ids } = this.fbParams;
      const index = ids.indexOf(tag.id);
      if (index > -1) {
        ids.splice(index, 1);
      } else {
        ids.push(tag.id);
      }

      Object.assign(this.fbParams, { ids });
    },

    /**
     * 问题是否解决
     */
    setResolved(isSolve) {
      Object.assign(this.fbParams, { isSolve });
    },

    /**
     * 提交表单
     */
    onSubmit() {
      if (this.fbParams.isDemo) return;
      const { disableSubmit } = this.fbParams;
      if (disableSubmit) return;
      if (!this.beforeSubmit()) {
        return;
      }
      Object.assign(this.fbParams, { editable: false });
      this.sendResult(this.fbParams);
    },

    beforeSubmit() {
      return true;
    },

    /**
     * 转换提交参数
     */
    async sendResult(result) {
      console.log('this.globalData', this.globalData);
      const tags = [];
      const tagsID = result.ids || [];
      console.log('this.msgDataBody', this.msgDataBody);
      (this.msgDataBody.tags || []).forEach((items) => {
        items.forEach((item) => {
          if (tagsID.indexOf(item.id) > -1) {
            tags.push(item);
          }
        });
      });

      const renderData = this.msgDataBody;
      const data = {
        fbLevel: result.value,
        fbDesc: result.text,
        isSolve: result.isSolve,
        tags,
        seq: renderData.seq,
        fbKey: renderData.fbKey,
        visitorId: this.to.user_id,
        kfuin: this.wpaDetail.kfUin,
        extUin: renderData.extUin,
        wpaId: this.wpaDetail.wpaId,
        session_time: this.data.time,
        sessionId: this.msgDataBody.sessionId,
        extendData: renderData.extendData,
      };

      // 整理tags参数
      const formData = qs.stringify(data);

      const url = `${CGI_FEED_BACK_SUBMIT_URL}?kfuin=${data.kfuin}`;
      const rs = await this.$ajax.post(url, formData);
      const resData = rs.data;
      if (resData.code || resData.r) {
        const text = rs.message || this.$t('chat_feedback_error_msg');
        this.$Toast({ text, type: 'error' });
      } else {
        const text = this.$t('chat_feedback_success_msg');
        this.$Toast(text);

        this.handleResultToDb(renderData);
      }
    },

    /**
     * 满意度调查提交后保存结果到db对应的数据中, 私有化版本不存本地，
     * @param {*} data 数据体
     */
    handleResultToDb() {
      imsdk.setMessageTags(this.data, [{
        tag: 'feed_back',
        value: JSON.stringify(this.msgDataBody),
      }]);
    },
  },
};
</script>

<style lang="less" scoped>
.feedback-wrap-box {

  .feedback-wrap {
    padding: 0 16px;
    background: #FFFFFF;
    border: 1px solid #E1E6F0;
    border-radius: 6px;
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
  }


  .feedback-evaluation, .feedback-mark-list, .feedback-opinion, .feedback-submit, .feedback-status {
    display: flex;
  }

  .feedback-evaluation {
    justify-content: space-between;
    &:before,
    &:after {
      content: '';
      display: block;
    }
  }

  .feedback-evaluation li {
    text-align: center;
  }

  .feedback-evaluation-text {
    font-family: PingFangSC-Regular;
    text-align: center;
    font-size: 14px;
    color: #A1ABC2;
    letter-spacing: 0;
    margin-top: 8px;
    &_active {
      color: #FF9A38;
    }
  }

  .feedback-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px 0;
  }

  .feedback-submit-btn {
    line-height: normal;
    padding: 8px 82px;
    background: @primary;
    border-radius: 3px;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    border: 0;
    cursor: pointer;
    &.is-disabled {
      opacity: .38;
      cursor: not-allowed;
    }
  }

  .feedback-evaluation-icon {
    width: 36px;
    height: 36px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .feedback-icon-veryDissatisfied {

    background-image: url("./img/veryDissatisfied.png");

    &_active {
      background-image: url("./img/veryDissatisfied_active.png");
    }
  }

  .feedback-icon-dissatisfied {

    background-image: url("./img/dissatisfied.png");

    &_active {
      background-image: url("./img/dissatisfied_active.png");
    }
  }

  .feedback-icon-neutral {

    background-image: url("./img/neutral.png");

    &_active {
      background-image: url("./img/neutral_active.png");
    }
  }

  .feedback-icon-satisfied {

    background-image: url("./img/satisfied.png");

    &_active {
      background-image: url("./img/satisfied_active.png");
    }
  }

  .feedback-icon-verySatisfied {

    background-image: url("./img/verySatisfied.png");

    &_active {
      background-image: url("./img/verySatisfied_active.png");
    }
  }
  .feedback-icon-start {
    background-image: url("./img/pc_ic_star_normal.png");

    &_active {
      background-image: url("./img/pc_ic_star_active.png");
    }
  }

  .feedback-evaluation-item {
    cursor: pointer;
    &_active{
      cursor: pointer;
      .feedback-evaluation-item_active-text{
        color: #FF9A38;
        text-align: center;
        font-size: 13px;
        margin-top: 8px;
      }
      .start-inline {
        display: inline-block;
        margin-right: 5px;
        margin-left: 6px;
      }
    }
  }
  .feedback-evaluation-wrap{
    margin: 16px 0;
  }
  .feedback-evaluation-result{
    text-align: center;
    .feedback-evaluation-item_active {
      cursor: default;
      white-space: nowrap;
    }
  }
  .feedback-container {
    background: white;
  }

  .feedback-mark-list {
    flex-wrap: wrap;
    margin-bottom: 10px;

    .feedback-tag {
      border-radius: 16px;
      padding: 4px 12px;
      margin-right: 4px;
      margin-left: 4px;
      margin-bottom: 8px;
      text-align: center;
      font-size: 0.75em;
      font-family: PingFangSC-Regular;
    }
    &.feedback-mark-list-label {
      justify-content: center;
      li {
        cursor: default;
      }
    }
  }

  .feedback-opinion {
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 16px;
    .feedback-textarea-wrap{
      position: relative;
      width: 100%;
      box-sizing: border-box;
    }

    .feedback-textarea {
      box-sizing: border-box;
      padding: 12px;
      width: 100%;
      box-sizing: border-box;
      resize: none;
      min-height: 100px;
      height: 100%;
      border: none;
      background: #F8F9FB;
      font-size: 14px;

      // 这里是设置textarea的placeholder的样式。但是组件有bug，输入内容后文字不消失。。所以先不使用这个样式了。
      &-placeholder{
        font-weight: normal;
        overflow: visible;
        vertical-align: top;
        display: inline-block !important;
        background-repeat: no-repeat;
        background-position: left;
        background-size: contain;
        color: #A1ABC2;
      }
    }

    .feedback-textarea-limit {
      position: absolute;
      bottom: 12px;
      right: 12px;
      font-family: PingFangSC-Regular;
      font-size: 0.75em;
      color: #A1ABC2;
      letter-spacing: 0;
    }

    .feedback-opinion-label {
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
      line-height: 20px;
      word-break: break-all;
      border: 1px solid #E1E6F0;
      border-radius: 3px;
      color: #262D3D;
      font-size: 13px;
    }
  }

  .feedback-tag {
    color: #A1ABC2;
    border: 1px solid #E1E6F0;
    cursor: pointer;
  }

  .feedback-tag-active {
    background: rgba(74, 112, 255, 0.10);
    border: 1px solid @primary;
    color: @primary;
    cursor: pointer;
  }

  .feedback-title {
    font-weight: 700;
    font-family: PingFangSC-Medium;
    font-size: 1em;
    color: #1E2330;
    text-align: center;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .feedback-status {
    display: flex;
    padding: 0 16px;
    margin: 16px 0;

  }

  .feedback-status-wrap {
    flex-grow: 1;
    display: flex;
    opacity: 0.9;
    border: 1px solid #E1E6F0;
    border-radius: 30px;
    padding: 8px 0;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    font-family: PingFangSC-Regular;
    font-size: 0.75em;
    color: #A1ABC2;
    cursor: pointer;
    &_active {
      background: rgba(74,112,255,0.10);
      color: @primary;
      border-color: @primary;
    }
    &_label {
      border-color: #fff;
      cursor: default;
    }
  }

  .feedback-status-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

  }

  .feedback-status-resolved {
    background-image: url("./img/resolved.png");

    &_active {
      background-image: url("./img/resolved_active.png");
    }
  }

  .feedback-status-unresolved {
    background-image: url("./img/unresolved.png");

    &_active {
      background-image: url("./img/unresolved_active.png");
    }
  }

  &-pc{
    width: 328px;
  }
}
</style>
